( function () {
	'use strict';

	var config = {
		'operatorGroup'      : 1,
		'filterPattern'      : /\-/g,
		'replacementPattern' : ';-;',
		'operatorKey'        : '-',
		'buttonDisplay'      : '<span class="icon-minus"></span>'
	};

	function run ( math ) {
		math.register( 'subtractionOperator', config );
	}

	angular
		.module( 'app.components' )
		.value( 'operatorSubtConfig', config )
		.run( run );

	run.$inject = [ 'mathOperatorService' ];
} )();
